<template>
<v-card :dark='dark' flat height='100%' >
    <v-img :src="backgroundImg"
      height="180px"
      gradient="to top, rgba(0,0,0,.44), rgba(0,0,0,.44)"
      :class='{"white--text": !dark}' >
      <v-layout>
        <v-menu >
          <template v-slot:activator="{ on }">
          <v-btn fab small absolute top right dark
            class='mt-4'
            v-on='on' slot='activator' >
            <v-icon>more_vert</v-icon>
          </v-btn>
          </template>
          <action-list v-if='appointment' :appointment='appointment' />
        </v-menu>
        <v-btn fab small absolute bottom right dark class='mb-5'
          v-if='sharelink && sharelink.url'
          @click='share' >
          <v-icon>share</v-icon>
        </v-btn>
        <v-flex xs11>
          <h3 class="title font-weight-light mt-3 ml-3 grow">
            {{appointment.title}}
            <small>with {{appointment.practitioner_name}}</small>
          </h3>
          <span class='ml-3' >{{appointment.product_name}} @ {{appointment.space_name}}</span>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
      <v-layout align-center>
        <strong class="display-4 font-weight-regular mr-4 ml-3">
          {{ dateformat(appointment.start_time, 'D') }}
        </strong>
        <v-layout column justify-end>
          <!--
          <v-btn @click="$emit('previous:week')" icon absolute left style='left:0px;top:80px' >
            <v-icon dark >chevron_left</v-icon>
          </v-btn >
          <v-btn @click="$emit('next:week')" icon absolute right style='top:80px' >
            <v-icon dark >chevron_right</v-icon>
          </v-btn >
          -->
          <div class="headline font-weight-light">
            {{ dateformat(appointment.start_time, 'ddd') }}
          </div>
          <div class="text-uppercase font-weight-light">{{ dateformat(appointment.start_time, 'MMMM YYYY')}}</div>
          <div>&nbsp;</div>

        </v-layout>
      </v-layout>
    </v-img>

    <!-- client -->
    <v-divider/>
    <v-list dense dark >
    <client-list-item with-details
      v-if='relationship && relationship.id'
      @listitem:clicked='gotoClient(relationship)'
      :relationship-id='relationship.id'
      :client='relationship.client' >
      <v-list-tile-avatar slot="avatar" >
        <v-icon>person</v-icon>
      </v-list-tile-avatar>
    </client-list-item>
    </v-list>
    <v-divider/>

    <!-- date and time -->
    <v-hover>
      <v-list-tile avatar slot-scope="{ hover }" >
        <v-list-tile-avatar>
          <v-icon>event</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title >Date and time</v-list-tile-title>
          <v-list-tile-sub-title >
            {{ formatFromTo(appointment.start_time, appointment.end_time) }}
          </v-list-tile-sub-title>
          <v-list-tile-sub-title v-if='appointment.client_timezone && appointment.client_timezone !== $store.getters.settings.timezone' >
            Client's timezone: {{appointment.client_timezone}}
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action >
          <v-btn small icon
            @click.stop="openGlobalDialog(true, 'Reschedule', {appointment})" >
            <v-icon small >edit</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-hover>
    <v-divider/>

    <!-- location details -->

    <!-- flexible location -->
    <template v-if='appointment.location && (appointment.location.address || appointment.location.name)' >
      <v-list-tile avatar >
        <v-list-tile-avatar>
          <v-icon>location_on</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title >Flexible location</v-list-tile-title>
          <v-list-tile-sub-title v-text='appointment.location.name' />
          <v-list-tile-sub-title v-text='appointment.location.formatted_address || appointment.location.address' >
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action v-if='appointment.location.url' >
          <v-btn :href='appointment.location.url' target='_blank' icon><v-icon>open_in_new</v-icon></v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </template>

    <!-- online -->
    <v-list-tile avatar v-else-if='appointment.zoom_join_url' >
      <v-list-tile-avatar>
        <v-icon>language</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title >Online</v-list-tile-title>
        <v-list-tile-sub-title >
          <a :href='appointment.zoom_join_url' title='Join URL' target='_blank' >
          {{appointment.zoom_join_url}}</a>
        </v-list-tile-sub-title>

        <v-list-tile-sub-title v-if='appointment.zoom_meeting_password' >
          Password: {{appointment.zoom_meeting_password}}
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action v-if='appointment.zoom_start_url' >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }" >
            <v-btn :href='appointment.zoom_start_url' v-on="on" target='_blank' icon >
              <v-icon>open_in_new</v-icon>
            </v-btn>
          </template>
          <span>Meeting start URL</span>
        </v-tooltip>
      </v-list-tile-action>
    </v-list-tile>

    <!-- standard address -->
    <v-list-tile avatar v-else-if='appointment.address_data' >
      <v-list-tile-avatar>
        <v-icon>location_on</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title >Location</v-list-tile-title>
        <v-list-tile-sub-title >
          {{appointment.address_data.name}}. {{appointment.address_data.address}}
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-divider/>

    <!-- appointment type -->
    <v-list-tile v-if='product && product.id' >
      <v-list-tile-avatar>
        <v-icon>star</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title >Appointment Type</v-list-tile-title>
        <v-list-tile-sub-title >
          {{ product.title }}
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <!-- <v-list-tile-action >
        <v-btn icon small >
          <v-icon small>edit</v-icon>
        </v-btn>
      </v-list-tile-action> -->
    </v-list-tile>
    <v-divider/>

    <template v-if="appointment.codes" >
      <!-- use value instead of v-model because read-only -->
      <appointment-codes
        dense with-title with-total
        :appointment-id='appointment.id'
        :value='appointment'
        :with-done='false' title='Codes' />
    </template>
    <slot name='card-actions' >
      <v-divider/>
      <v-card-actions >
        <v-spacer/>
        <v-btn >Open</v-btn>
      </v-card-actions>
    </slot>
</v-card>
</template>
<script>
import AppointmentCodes from '@/components/appointment/AppointmentCodes.vue'
import ClientListItem from '@/components/client/ClientListItem.vue'
import ShareCard from '@/components/cards/ShareCard.vue'
import ActionList from '@/components/appointment/actions/ActionList.vue'
import {BACKGROUNDS} from '@/components/home/backgrounds'
// import Vue from 'vue'

export default {
  name: 'SmallAppointmentCard',
  props: {
    value: { type: Object, required: true },
    dark: { type: Boolean, default: false }
  },
  components: {
    AppointmentCodes,
    ShareCard,
    ClientListItem,
    ActionList
  },
  data () {
    return {}
  },
  methods: {
    share () {
      let options = {
        links: [this.sharelink],
        relationship: this.relationshipId
      }
      this.launchShareDialog(options)
    }
  },
  watch: {
    // appointmentId: {
    //   immediate: true,
    //   handler () {
    //     if (this.appointmentId !== 0) {
    //       // this.appointment = Object.assign({}, this.value)
    //       console.log(this.value)
    //       Vue.set(this, 'appointment', this.value)
    //       // this.appointment = this.value
    //     }
    //   }
    // }
  },
  computed: {
    appointment: {
      get () {
        return this.value
      },
      set (val) {
        console.log('spot the difference', this.value, val)
        // this.$emit('input', val)
      }
    },
    backgroundImg () {
      if (this.product && this.product.background_picture) {
        return this.product.background_picture
      }
      return this.backupBackgroundImg
    },
    timeOfDay () {
      let currentHour = new Date().getHours()
      if (currentHour >= 12 && currentHour <= 17) return 'afternoon'
      else if (currentHour >= 18) return 'evening'
      else return 'morning'
    },
    backupBackgroundImg () {
      let images = BACKGROUNDS[this.timeOfDay]
      let index = Math.floor(Math.random() * images.length)
      return images[index]
    },
    appointmentId () {
      if (this.value) { return this.value.id }
      return 0
    },
    relationshipId () {
      if (this.appointment && this.appointment.computed_relationship_id) {
        return this.appointment.computed_relationship_id
      }
      if (this.appointment && this.appointment.relationships && this.appointment.relationships.length === 1) {
        return this.appointment.relationships[0]
      }
      return null
    },
    relationship () {
      if (this.relationshipId) { return this.getRelationById(this.relationshipId) }
      return null
    },
    product () {
      if (this.appointment && this.appointment.product) {
        return this.getProductById(this.appointment.product)
      }
      return null
    },
    sharelink () {
      return {
        url: this.getObjectPath(this.appointment, 'client_detail_url', null),
        title: this.appointment.title
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// SmallAppointmentCard.vue?10e058d3